import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BatchTypeFormValues } from "src/models/BatchType.model";
import BatchType from "../Layouts/BatchTypeForm";
import {
  useGetBatchTypeByIdQuery,
  useUpdateBatchTypeByIdMutation,
} from "src/services/BatchTypeService";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedBatchTypeId: string;
};

const EditBatchTypeWrapper = ({ onClose, selectedBatchTypeId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetBatchTypeByIdQuery(selectedBatchTypeId);
  const [updateBatchTypeById] = useUpdateBatchTypeByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: BatchTypeFormValues = {
    batchTypeName: items?.batchTypeName || "",
    batchTypeCode: items?.batchTypeCode || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchTypeName: string().required("Please enter Batch Type name"),
    batchTypeCode: string().required("Please enter Batch Type code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchTypeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchTypeFormValues>
  ) => {
    const payload = {
      batchTypeName: values.batchTypeName,
      batchTypeCode: values.batchTypeCode,
    };
    updateBatchTypeById({ id: selectedBatchTypeId, body: payload }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <BatchType
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBatchTypeWrapper;
